import type { JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { useIsOdesaTemplate } from '~/utilities/useIsOdesaTemplate';

const cssClasses = cva('mb-0 md:mb-9 relative', {
  variants: {
    margin: {
      none: 'mx-0',
      default: 'md:mx-10 md:mb-9',
    },
    isOdesa: {
      true: 'mb-5 md:mb-5',
      false: '',
    },
  },
});

interface ArticleCoverProps {
  margin?: 'none' | 'default';
}

export default component$<ArticleCoverProps>(
  ({ margin = 'default' }): JSX.Element => {
    const isOdesa = useIsOdesaTemplate();
    return (
      <div class={cssClasses({ margin, isOdesa })}>
        <Slot />
      </div>
    );
  }
);
